module.exports = __webpack_public_path__ + "static/media/gig-approved.d9f89bfe.png";